import script from "./Cenik.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cenik.vue?vue&type=script&setup=true&lang=ts"

import "./Cenik.vue?vue&type=style&index=0&id=745180e6&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745180e6"]])

export default __exports__